import { ArrowTrendingDownIcon, ArrowTrendingUpIcon, ArrowRightIcon  } from "components/Icons";

function StatCard({ title, number, day, month, bgColor, borderColor, growth, amount }) {
  const growthColor = growth > 0 ? 'text-green-600' : growth < 0 ? 'text-red-600' : 'text-gray-400';
  const growthIcon = growth > 0
    ? <ArrowTrendingUpIcon className="w-5 fill-current text-green-600" />
    : growth < 0
      ? <ArrowTrendingDownIcon className="w-4 fill-current text-red-600" />
      : <ArrowRightIcon className="w-4 fill-current text-gray-400" />;
  return (
    <div className={`${bgColor} ${borderColor} border w-full rounded-2xl p-4 flex flex-col justify-between shadow-lg`}>
      <div className="flex items-center justify-between">
        <div className="font-semibold text-base text-gray-700">{title}</div>
      </div>
      <div className="flex justify-between gap-3 items-center pt-4">
        <div className="flex flex-row space-x-5 ">
          <div className="text-4xl font-bold text-gray-800 leading-none">{number}</div>
          {growth !== undefined && (
            <div className={`text-xs font-semibold ${growthColor}`}>
              {growthIcon} {Math.abs(growth).toFixed()}%
            </div>
          )}
        </div>
        <div className="flex flex-col leading-tight">
          <div className="text-2xl font-semibold text-gray-700">{day}</div>
          <div>{amount !== undefined && (
            <div className="text-xl text-gray-600 font-medium mt-2">
              $ {Number(amount).toLocaleString()}
            </div>
          )}</div>
          <div className="text-sm text-gray-500 uppercase tracking-wide">{month}</div>
        </div>
      </div>
    </div>
  );
}

export default StatCard;
